import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=b17e52a0&scoped=true"
import script from "./kaoshi.vue?vue&type=script&lang=js"
export * from "./kaoshi.vue?vue&type=script&lang=js"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=b17e52a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17e52a0",
  null
  
)

export default component.exports